export enum CreateNewCaseSteps {
  ClaimInfo = 0,
  DebtorInfo = 1,
  CaseInfo = 2,
  Messages = 3,
  Done = 4,
}
